import { LinkButton } from '@euler/app/components/LinkButton';
import { useUserLocalSettings } from '@euler/app/flows/settings/functions/useUserLocalSettings';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';

export const WiredRememberLastAssignButton = memo(() => {
  const { rpx } = useResponsiveContext();
  const [{ rememberLastServiceSubjectAssignment }, updateSettings] =
    useUserLocalSettings();

  return (
    <LinkButton
      text="记住并默认沿用首次派工对象"
      textStyle={{
        fontSize: rpx(12),
        color: '#777',
      }}
      icon={
        <Icon
          color={'#777'}
          size={rpx(13)}
          name={
            rememberLastServiceSubjectAssignment
              ? 'checkbox'
              : 'checkbox_outline'
          }
        />
      }
      onPress={() =>
        updateSettings(v => ({
          ...v,
          rememberLastServiceSubjectAssignment:
            !v?.rememberLastServiceSubjectAssignment,
        }))
      }
    />
  );
});
